import { Surplus } from 'lib/api/reports/types';

import { SurplusReportGenerator } from './surplusReportGenerator';

export const generateSurplusReportPDF = async (
  surplus: Surplus,
  userName: string,
  imageBase64: string,
) => {
  const generator = new SurplusReportGenerator({
    userName,
    imageBase64,
    title: 'Detalle Excedente',
    fileName: `REPORTE-EXCEDENTE-${surplus.documentFolio}.pdf`,
    surplus,
  });

  await generator.generate();
};
